import React, { useState, useEffect } from 'react';
import axios from 'axios';

// La aplicación utiliza rutas relativas /api tanto en desarrollo como en producción.
// En desarrollo, setupProxy.js las envía al backend local/configurado.
// En producción, Nginx Proxy Manager enruta /api al backend.
axios.defaults.withCredentials = false;

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  
  // Detectar automáticamente el modo oscuro guardado en el sistema
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem('theme');
    const darkModeActive = savedTheme === 'dark';
    setIsDarkMode(darkModeActive);
    document.body.style.backgroundColor = darkModeActive ? '#0f172a' : '#f7fafc';
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // Gracias a la configuración global de arriba, esta petición automática viajará a:
      // https://gycai.net/api/auth/login
      const response = await axios.post('/api/auth/login', { email, password }, { withCredentials: false });
      localStorage.setItem('token', response.data.token);
      onLogin(response.data.token);
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      alert(error.response?.data?.message || 'Credenciales incorrectas. Inténtalo de nuevo.');
    } finally {
      setIsLoading(false);
    }
  };

  // Variables de diseño adaptivas según el tema
  const formBg = isDarkMode ? '#1e293b' : '#ffffff';
  const textCol = isDarkMode ? '#f8fafc' : '#2d3748';
  const subtitleCol = isDarkMode ? '#94a3b8' : '#718096';
  const borderCol = isDarkMode ? '#334155' : '#e2e8f0';
  const inputBg = isDarkMode ? '#334155' : '#ffffff';

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '85vh',
      fontFamily: '"Segoe UI", Roboto, sans-serif',
      padding: '20px'
    }}>
      <div style={{ 
        background: formBg, 
        padding: '40px', 
        borderRadius: '16px', 
        boxShadow: isDarkMode ? '0 10px 25px rgba(0,0,0,0.4)' : '0 10px 25px rgba(0,0,0,0.05)', 
        width: '100%', 
        maxWidth: '400px',
        border: `1px solid ${borderCol}`,
        transition: 'all 0.3s ease'
      }}>
        
        {/* Encabezado del Formulario */}
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <span style={{ fontSize: '45px' }}>🕒</span>
          <h2 style={{ margin: '10px 0 5px 0', color: textCol, fontSize: '24px', fontWeight: 'bold' }}>
            Reloj Checador 3.0
          </h2>
          <p style={{ margin: 0, color: subtitleCol, fontSize: '14px' }}>
            Introduce tus credenciales para acceder al panel
          </p>
        </div>

        {/* Formulario */}
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          
          {/* Campo Correo */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 'bold', color: textCol }}>
              Correo Electrónico
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nombre@empresa.com"
              required
              style={{ 
                width: '100%', 
                padding: '12px 14px', 
                borderRadius: '8px', 
                border: `1px solid ${borderCol}`, 
                backgroundColor: inputBg, 
                color: textCol, 
                boxSizing: 'border-box',
                fontSize: '15px',
                outline: 'none',
                transition: 'border-color 0.2s'
              }}
            />
          </div>

          {/* Campo Contraseña */}
          <div>
            <label style={{ display: 'block', marginBottom: '8px', fontSize: '14px', fontWeight: 'bold', color: textCol }}>
              Contraseña
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              style={{ 
                width: '100%', 
                padding: '12px 14px', 
                borderRadius: '8px', 
                border: `1px solid ${borderCol}`, 
                backgroundColor: inputBg, 
                color: textCol, 
                boxSizing: 'border-box',
                fontSize: '15px',
                outline: 'none',
                transition: 'border-color 0.2s'
              }}
            />
          </div>

          {/* Botón de Envío */}
          <button 
            type="submit" 
            disabled={isLoading}
            style={{ 
              padding: '14px', 
              backgroundColor: '#3182ce', 
              color: 'white', 
              border: 'none', 
              borderRadius: '8px', 
              fontWeight: 'bold', 
              cursor: isLoading ? 'not-allowed' : 'pointer', 
              fontSize: '16px',
              boxShadow: '0 4px 6px rgba(49, 130, 206, 0.2)',
              marginTop: '10px',
              transition: 'background 0.2s, transform 0.1s',
              opacity: isLoading ? 0.7 : 1
            }}
          >
            {isLoading ? 'Verificando...' : '🚀 Iniciar Sesión'}
          </button>
        </form>

      </div>
    </div>
  );
};

export default LoginForm;
